export type Lang = 'pt' | 'en' | 'de';

export function normalizeLang(lang?: string): Lang {
  const base = (lang || 'pt').split('-')[0].toLowerCase();
  if (base === 'en' || base === 'de' || base === 'pt') {
    return base;
  }
  return 'pt';
}

export const sectionSlugs: Record<string, Record<Lang, string>> = {
  categories: {
    pt: 'cssbuy-spreadsheet-guia-completo',
    en: 'cssbuy-spreadsheet-complete-guide',
    de: 'cssbuy-spreadsheet-kompletter-leitfaden',
  },
  guides: {
    pt: 'cssbuy-spreadsheet-guia-completo',
    en: 'cssbuy-spreadsheet-complete-guide',
    de: 'cssbuy-spreadsheet-kompletter-leitfaden',
  },
  qc: {
    pt: 'cssbuy-qc-guia',
    en: 'cssbuy-qc-guide',
    de: 'cssbuy-qc-leitfaden',
  },
  shipping: {
    pt: 'cssbuy-shipping-cost-guia',
    en: 'cssbuy-shipping-cost-guide',
    de: 'cssbuy-versandkosten-leitfaden',
  },
  comparisons: {
    pt: 'cssbuy-vs-superbuy',
    en: 'cssbuy-vs-superbuy',
    de: 'cssbuy-vs-superbuy',
  },
  safety: {
    pt: 'cssbuy-safety-guide',
    en: 'cssbuy-safety-guide',
    de: 'cssbuy-safety-guide',
  },
};